var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3945_3186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.88529 7.32297L6.96879 8.46897C5.54861 7.63456 4.36519 6.45114 3.53079 5.03097L4.67679 4.11447C4.81112 4.00696 4.90607 3.85799 4.94677 3.69082C4.98748 3.52364 4.97166 3.3477 4.90179 3.19047L3.85704 0.837716C3.78211 0.66912 3.64975 0.532612 3.48354 0.45253C3.31733 0.372447 3.12808 0.353996 2.94954 0.400466L0.960535 0.915716C0.775015 0.964359 0.61374 1.07928 0.507194 1.23875C0.400647 1.39823 0.356212 1.59121 0.382285 1.78122C0.731255 4.26652 1.87987 6.57065 3.65449 8.34527C5.4291 10.1199 7.73323 11.2685 10.2185 11.6175C10.4085 11.6437 10.6014 11.5993 10.7608 11.4927C10.9202 11.3861 11.0349 11.2248 11.0833 11.0392L11.5993 9.05097C11.6458 8.87242 11.6273 8.68317 11.5472 8.51696C11.4671 8.35076 11.3306 8.21839 11.162 8.14347L8.80929 7.09872C8.65209 7.02902 8.47627 7.01322 8.30917 7.05377C8.14206 7.09433 7.99304 7.18897 7.88529 7.32297V7.32297Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3945_3186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatphone);
export default __webpack_public_path__ + "static/media/chatphone.bafda5dab7676a2f339761ba289e945a.svg";
export { ForwardRef as ReactComponent };